import React from 'react';
import PropTypes from 'prop-types';

import NumberFormat from 'react-number-format';
import TextField from '@material-ui/core/TextField';
import useStyles from './styles';

function Distance({value, ...rest}) {

  const classes = useStyles();

  return (
    <TextField
      className={classes.formControl}
      id='distance'
      name='distance'
      label='Distância'
      placeholder='Distância'
      autoComplete='off'
      InputLabelProps={{
        shrink: true
      }}
      InputProps={{
        inputComponent: NumberFormatCustom,
        value
      }}
      {...rest}
    />
  );
}

Distance.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool
};

function NumberFormatCustom({inputRef, name, onChange, ...rest}) {

  const _onChange = values => {
    onChange({
      target: {
        name,
        value: values.value,
      },
    });
  };

  return (
    <NumberFormat
      isNumericString
      allowNegative={false}
      decimalScale={0}
      getInputRef={inputRef}
      thousandSeparator={'.'}
      decimalSeparator={','}
      onValueChange={_onChange}
      suffix=' Km'
      {...rest}
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string
};

export default Distance;
